import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabfare() {



    const cardData = {

keyword: "Pune Cab Fare",

headingDescription:
    "Rising Cab Service offers affordable and transparent Pune Cab Fare for local, airport, railway station, and outstation travel. We provide budget-friendly Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania cabs for families, business travelers, and tourists. Our pricing is competitive with no hidden charges, ensuring value for money and a comfortable travel experience. With professional drivers, 24/7 booking support, and well-maintained vehicles, Rising Cab Service makes cab travel in and from Pune convenient, safe, and cost-effective.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most popular cab destinations from Pune, known for Gateway of India, Marine Drive, Juhu Beach, Siddhivinayak Temple, and vibrant city life. Travelers frequently book one-way and round-trip cabs for business and leisure visits."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for waterfalls, green valleys, Tiger Point, Bhushi Dam, and pleasant weather. It is among the most preferred short-distance cab trips from Pune."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station known for strawberry farms, Venna Lake, Arthur's Seat, and breathtaking viewpoints. It is a popular family and honeymoon destination."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba. Devotees from Pune regularly hire cabs for comfortable one-day and weekend darshan trips."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar is one of the twelve Jyotirlingas of Lord Shiva and is surrounded by the Sahyadri hills and wildlife sanctuary, making it a spiritual and nature-filled destination."
    },
    {
        title: "Nashik",
        description:
            "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchvati, Godavari Ghats, and vineyards. It offers a blend of pilgrimage, history, and wine tourism."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is well known for the Mahalakshmi Temple, Panhala Fort, traditional cuisine, and rich Maratha heritage, making it a popular outstation route from Pune."
    },
    {
        title: "Goa",
        description:
            "Goa attracts travelers with its beautiful beaches, water sports, nightlife, churches, and Portuguese architecture. It is a favorite long-distance cab destination from Pune."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for the UNESCO-listed Ajanta and Ellora Caves, Bibi Ka Maqbara, and Daulatabad Fort, offering a rich historical and cultural experience."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a charming coastal destination known for its beaches, sea forts, water activities, and peaceful atmosphere, making it an ideal weekend getaway from Pune."
    }
],



services: [
    {
        name: "Pune Cab Fare",
        description:
            "Rising Cab Service provides transparent Pune Cab Fare for local, airport, and outstation travel with affordable pricing and no hidden charges. Our fare structure is designed to suit daily commuters, families, tourists, and business travelers looking for reliable transportation in Pune. Customers can choose from hatchbacks, sedans, SUVs, Innova Crysta, and premium vehicles with pricing based on distance and trip type. We ensure fair rates, professional drivers, and comfortable rides for every journey."
    },
    {
        name: "Taxi Fare Pune",
        description:
            "Our Taxi Fare Pune service offers economical and competitive pricing for all travel requirements. Whether you need a taxi for local city travel, airport transfers, railway station pickups, or long-distance journeys, Rising Cab Service provides affordable rates with clean vehicles and experienced drivers. We focus on transparent pricing, quality service, and customer satisfaction."
    },
    {
        name: "Cab Charges Pune",
        description:
            "Rising Cab Service offers clear Cab Charges Pune for local and outstation trips with no hidden costs. Charges are calculated according to vehicle category, travel distance, and trip duration, ensuring complete fare transparency. We provide cost-effective travel solutions for business trips, family outings, airport transfers, and long-distance journeys."
    },
    {
        name: "Pune Taxi Price",
        description:
            "Get the best Pune Taxi Price with Rising Cab Service for comfortable and affordable travel. We provide flexible pricing for local rides, airport pickups, and intercity travel with well-maintained vehicles and professional drivers. Our taxi prices are designed to offer maximum value while maintaining safety and comfort."
    },
    {
        name: "Cab Fare Calculator Pune",
        description:
            "Our Cab Fare Calculator Pune helps customers estimate travel expenses before booking. Rising Cab Service provides accurate fare estimates based on distance, route, and vehicle type, making trip planning easy and transparent for local and outstation travel."
    },
    {
        name: "Pune Cab Rates Per KM",
        description:
            "Rising Cab Service offers transparent Pune Cab Rates Per KM for hatchbacks, sedans, SUVs, and luxury vehicles. Our per-kilometer pricing helps customers understand travel costs in advance for local rides, airport transfers, and outstation journeys."
    },
    {
        name: "Outstation Cab Fare Pune",
        description:
            "Our Outstation Cab Fare Pune offers affordable pricing for travel to Mumbai, Goa, Shirdi, Nashik, Mahabaleshwar, Kolhapur, Aurangabad, and other destinations. We provide safe highway travel with experienced drivers and comfortable vehicles."
    },
    {
        name: "Local Cab Fare Pune",
        description:
            "Rising Cab Service provides Local Cab Fare Pune with economical pricing for daily commuting, shopping, office travel, sightseeing, and short-distance city rides. Our affordable local fares make traveling across Pune easy and convenient."
    },
    {
        name: "Pune Airport Cab Fare",
        description:
            "Get transparent Pune Airport Cab Fare with Rising Cab Service for airport pickups and drops. We offer fixed and distance-based pricing with 24x7 service, ensuring timely and comfortable airport transportation."
    },
    {
        name: "One Way Cab Fare Pune",
        description:
            "Our One Way Cab Fare Pune provides affordable pricing for single-direction travel without unnecessary return charges. Ideal for airport transfers, business travel, and intercity journeys."
    },
    {
        name: "Round Trip Cab Fare Pune",
        description:
            "Rising Cab Service offers Round Trip Cab Fare Pune with flexible travel plans including waiting time and return journeys. Perfect for family trips, business travel, and sightseeing tours."
    },
    {
        name: "Cheapest Cab Fare Pune",
        description:
            "Book Cheapest Cab Fare Pune with Rising Cab Service for budget-friendly travel without compromising comfort or safety. Our economical fare plans are suitable for local and outstation journeys."
    },
    {
        name: "Cab Price Estimate Pune",
        description:
            "Our Cab Price Estimate Pune service helps customers calculate approximate travel costs before booking. We ensure accurate estimates and complete pricing transparency for all travel requirements."
    },
    {
        name: "Taxi Rate Pune City",
        description:
            "Rising Cab Service offers affordable Taxi Rate Pune City for local transportation with fair pricing, professional drivers, and comfortable vehicles for everyday travel."
    },
    {
        name: "Affordable Cab Fare Pune",
        description:
            "Get Affordable Cab Fare Pune for city rides, airport transfers, and outstation trips with transparent pricing and dependable service from Rising Cab Service."
    },
    {
        name: "Pune to Shirdi Cab Charges",
        description:
            "Rising Cab Service provides Pune to Shirdi Cab Charges with affordable pricing for one-way and round-trip pilgrimages to Sai Baba Temple, ensuring safe and comfortable travel."
    },
    {
        name: "Pune to Shirdi Cab Fare",
        description:
            "Our Pune to Shirdi Cab Fare offers economical travel packages with experienced drivers and comfortable vehicles for family and devotional trips."
    },
    {
        name: "Pune to Mumbai Airport Cab Fare",
        description:
            "Book Pune to Mumbai Airport Cab Fare with Rising Cab Service for reliable airport transfers with transparent pricing and timely service."
    },
    {
        name: "Pune to Mumbai Cab Fare",
        description:
            "Rising Cab Service offers Pune to Mumbai Cab Fare with affordable one-way and round-trip options, ensuring safe and comfortable intercity travel."
    },
    {
        name: "Pune to Mumbai Cab Charges",
        description:
            "Our Pune to Mumbai Cab Charges are transparent and budget-friendly, with multiple vehicle options available for business and leisure travel."
    },
    {
        name: "Pune to Bhimashankar Taxi Fare",
        description:
            "Rising Cab Service provides Pune to Bhimashankar Taxi Fare for temple visits with safe drivers, comfortable vehicles, and affordable pilgrimage travel packages."
    },
    {
        name: "Pune Mumbai Taxi Fare",
        description:
            "Get competitive Pune Mumbai Taxi Fare with Rising Cab Service for smooth highway travel and reliable one-way or round-trip transportation."
    },
    {
        name: "Pune to Bhimashankar Cab Fare",
        description:
            "Our Pune to Bhimashankar Cab Fare ensures affordable and comfortable travel for devotees and tourists with experienced drivers."
    },
    {
        name: "Pune to Mumbai Cab Cost",
        description:
            "Rising Cab Service offers transparent Pune to Mumbai Cab Cost with flexible vehicle choices and economical travel packages."
    },
    {
        name: "Pune to Goa Taxi Fare",
        description:
            "Book Pune to Goa Taxi Fare with Rising Cab Service for safe, comfortable, and affordable long-distance travel to Goa."
    },
    {
        name: "Pune to Trimbakeshwar Cab Fare",
        description:
            "Our Pune to Trimbakeshwar Cab Fare provides economical pilgrimage travel with reliable vehicles and experienced drivers."
    },
    {
        name: "Pune to Aurangabad Taxi Fare",
        description:
            "Rising Cab Service offers Pune to Aurangabad Taxi Fare with affordable pricing and comfortable travel for business and tourism."
    },
    {
        name: "Pune Airport to Shirdi Distance Taxi Fare",
        description:
            "Get Pune Airport to Shirdi Distance Taxi Fare with fixed and transparent pricing for direct airport pickup and comfortable pilgrimage travel."
    },
    {
        name: "Pune to Mumbai Taxi Price",
        description:
            "Our Pune to Mumbai Taxi Price offers budget-friendly and premium travel options with safe drivers and comfortable vehicles."
    },
    {
        name: "Cab Rate Per KM in Pune",
        description:
            "Rising Cab Service provides Cab Rate Per KM in Pune for local and outstation journeys with transparent pricing across all vehicle categories."
    },
    {
        name: "Pune to Goa Cab Fare",
        description:
            "Book Pune to Goa Cab Fare with affordable travel packages and comfortable long-distance transportation."
    },
    {
        name: "Pune to Aurangabad Cab Fare",
        description:
            "Our Pune to Aurangabad Cab Fare provides economical outstation travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Cab Fare in Pune",
        description:
            "Rising Cab Service offers Cab Fare in Pune for local, airport, and outstation rides with affordable rates and transparent billing."
    },
    {
        name: "Cab Rates in Pune",
        description:
            "Get the latest Cab Rates in Pune for hatchbacks, sedans, SUVs, and premium vehicles with cost-effective pricing for every travel requirement."
    },
    {
        name: "Pune Taxi Fare",
        description:
            "Our Pune Taxi Fare ensures affordable and reliable transportation for local and intercity travel with professional drivers."
    },
    {
        name: "Cab Fare in Pune",
        description:
            "Book Cab Fare in Pune with Rising Cab Service for budget-friendly city and outstation travel backed by quality service."
    },
    {
        name: "Pune Cab Fare Per KM",
        description:
            "Rising Cab Service offers Pune Cab Fare Per KM with clear distance-based pricing for local and long-distance journeys."
    },
    {
        name: "Cheap Cab Fare Pune",
        description:
            "Get Cheap Cab Fare Pune with Rising Cab Service for economical local and outstation transportation without compromising safety and comfort."
    }
],

tableData: [
    ["Pune Cab Fare", "Taxi Fare Pune"],
    ["Cab Charges Pune", "Pune Taxi Price"],
    ["Cab Fare Calculator Pune", "Pune Cab Rates Per KM"],
    ["Outstation Cab Fare Pune", "Local Cab Fare Pune"],
    ["Pune Airport Cab Fare", "One Way Cab Fare Pune"],
    ["Round Trip Cab Fare Pune", "Cheapest Cab Fare Pune"],
    ["Cab Price Estimate Pune", "Taxi Rate Pune City"],
    ["Affordable Cab Fare Pune", "Pune to Shirdi Cab Charges"],
    ["Pune to Shirdi Cab Fare", "Pune to Mumbai Airport Cab Fare"],
    ["Pune to Mumbai Cab Fare", "Pune to Mumbai Cab Charges"],
    ["Pune to Bhimashankar Taxi Fare", "Pune Mumbai Taxi Fare"],
    ["Pune to Bhimashankar Cab Fare", "Pune to Mumbai Cab Cost"],
    ["Pune to Goa Taxi Fare", "Pune to Trimbakeshwar Cab Fare"],
    ["Pune to Aurangabad Taxi Fare", "Pune Airport to Shirdi Distance Taxi Fare"],
    ["Pune to Mumbai Taxi Price", "Cab Rate Per KM in Pune"],
    ["Pune to Goa Cab Fare", "Pune to Aurangabad Cab Fare"],
    ["Cab Fare in Pune", "Cab Rates in Pune"],
    ["Pune Taxi Fare", "Pune Cab Fare Per KM"],
    ["Cheap Cab Fare Pune", "Pune Taxi Price"]
],




whychoose: [
    {
        WhyChooseheading: "Transparent Pune Cab Fare Options",
        WhyChoosedescription: "Rising Cab Service offers clear and competitive Pune cab fare plans for local travel, airport transfers, outstation trips, corporate transportation, and sightseeing tours."
    },
    {
        WhyChooseheading: "Fare Plans for Every Travel Requirement",
        WhyChoosedescription: "Whether you need a short city ride, full-day booking, one-way journey, or long-distance trip, we provide fare options designed to suit different travel needs."
    },
    {
        WhyChooseheading: "Wide Range of Vehicles at Competitive Rates",
        WhyChoosedescription: "Customers can select from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to their budget and group size."
    },
    {
        WhyChooseheading: "Cost-Effective Airport Transportation",
        WhyChoosedescription: "Our airport transfer services offer affordable pricing while ensuring timely pickup and drop facilities across Pune and PCMC."
    },
    {
        WhyChooseheading: "Flexible Booking Packages",
        WhyChoosedescription: "Choose from hourly rentals, full-day packages, local city travel plans, outstation fares, and customized travel arrangements."
    },
    {
        WhyChooseheading: "Suitable for Personal and Business Travel",
        WhyChoosedescription: "Our fare structures are designed to serve families, tourists, students, corporate employees, and business travelers alike."
    },
    {
        WhyChooseheading: "Convenient Service Across Pune",
        WhyChoosedescription: "Pickup and drop services are available throughout Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, and surrounding locations."
    },
    {
        WhyChooseheading: "Value for Money Travel Experience",
        WhyChoosedescription: "Rising Cab Service combines reasonable pricing, professional drivers, and comfortable vehicles to deliver excellent travel value."
    }
]
};

const faqData = [
    {
        question: "How is Pune cab fare generally calculated?",
        answer: "Cab fares are typically calculated based on distance traveled, travel duration, vehicle category, route, and service type."
    },
    {
        question: "Do local and outstation fares differ?",
        answer: "Yes, local city travel and outstation journeys usually have different fare structures based on distance and duration."
    },
    {
        question: "Which vehicle category is usually the most economical?",
        answer: "Sedan vehicles are commonly chosen by travelers looking for budget-friendly transportation options."
    },
    {
        question: "Are airport transfer charges fixed or distance-based?",
        answer: "Airport transfer pricing may vary depending on pickup location, travel time, and vehicle category."
    },
    {
        question: "Can customers request fare details before booking?",
        answer: "Yes, fare estimates can be provided before confirming the booking to help customers plan their travel budget."
    },
    {
        question: "Do group vehicles have separate pricing plans?",
        answer: "Yes, Tempo Travellers, Mini Buses, and larger vehicles are priced according to seating capacity and travel requirements."
    },
    {
        question: "Are round-trip fares different from one-way fares?",
        answer: "Yes, pricing varies depending on whether customers choose one-way transportation or a return journey."
    },
    {
        question: "Can full-day vehicle rental packages be arranged?",
        answer: "Yes, full-day and multi-day packages are available for local travel, sightseeing, business visits, and special occasions."
    },
    {
        question: "Do seasonal travel periods affect cab availability?",
        answer: "During holidays, festivals, and weekends, advance booking is recommended to ensure vehicle availability."
    },
    {
        question: "How can travelers get the latest Pune cab fare information?",
        answer: "Customers can contact Rising Cab Service through phone, WhatsApp, or online inquiry to receive current fare details."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prasad Kulkarni",
        feedback:
            "Comparing several transportation options led me to Rising Cab Service. The pricing was straightforward, and the quality of service made it an excellent choice for regular travel.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Smita Jadhav",
        feedback:
            "Affordable rates combined with professional service created a great travel experience. The journey was comfortable, and the overall value exceeded expectations.",
        rating: 5
    }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Cab Fare",
"image": "https://www.risingcabservice.com/assets/images/pune-cab-fare.jpg",
"description": "Check Pune Cab Fare with Rising Cab Service for local travel, airport transfers, and outstation trips. Get transparent pricing, affordable taxi rates, and reliable cab service for all destinations in and around Pune.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-cab-fare"
}
};







    return (
        <div>

<Helmet>
  <title>Pune Cab Fare | Taxi Charges & Price Per KM | +91 9272511548</title>

<meta
 name="description"
 content="Check Pune cab fare, taxi charges, and price per km for local and outstation trips. Get affordable and transparent cab rates for Pune airport, Shirdi, Mumbai, and other destinations."
/>

<meta
 name="keywords"
 content="pune cab fare, taxi fare pune, cab charges pune, pune taxi price, cab fare calculator pune, pune cab rates per km, outstation cab fare pune, local cab fare pune, pune airport cab fare, one way cab fare pune, round trip cab fare pune, cheapest cab fare pune, cab price estimate pune, taxi rate pune city, affordable cab fare pune, Pune to shirdi cab charges, Pune to shirdi cab fare, Pune to mumbai airport cab fare"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punecabfare;